<template>
  <div class="page">
    <van-nav-bar title="实习变更" left-arrow @click-left="$router.go(-1)" z-index="99999" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-form @submit="onSubmit">
      <div class="bblock">企事业单位信息</div>
      <van-field required  name="所属单位" readonly @click="showPicker4 = true" clickable is-link :value="form.ssqymc" input-align="right" error-message-align="right" label="所属单位" :rules="[{ required: true, message: '请选择所属单位', trigger: 'onChange' }]" />
      <van-popup v-model="showPicker4" round position="bottom">
        <findPopup v-if="schoolCode === '10848'" @closePop="onConfirm4" :list="preData[7].list || []" :isRadio="false"></findPopup>
        <van-picker v-else show-toolbar :columns="preData[7].list || []" @cancel="showPicker4 = false" @confirm="onConfirm4" />
      </van-popup>
      <van-field required  name="实习基地" readonly @click="showPicker3 = true" clickable is-link :value="form.sxjdmc" input-align="right" error-message-align="right" label="实习基地" :rules="[{ required: true, message: '请选择实习基地', trigger: 'onChange' }]" />
      <van-popup v-model="showPicker3" round position="bottom">
        <findPopup  v-if="schoolCode === '10848'" @closePop="onConfirm3" :list="jdList" :isRadio="false"></findPopup>
        <van-picker v-else show-toolbar :columns="jdList" @cancel="showPicker3 = false" @confirm="onConfirm3" />
      </van-popup>
      <van-field  name="基地类别" readonly disabled input-align="right" v-model="pickerData"  label="基地类别"  />
      <van-field name="基地负责人" readonly disabled input-align="right" v-model="form.jdfzr" label="基地负责人"  />
      <van-field name="基地电话" readonly disabled input-align="right" v-model="form.jddh" label="基地电话" />
      <van-field  v-model="form.jddz" name="基地地址" label="基地地址" readonly disabled input-align="right" />
      
      <div class="bblock"  v-if="schoolCode != '10422'">岗位信息</div>

      <van-field  v-if="schoolCode != '10422'"  :value="form.gwmc" readonly clickable is-link @click="showPicker5 = true" name="实习岗位" label="实习岗位" input-align="right" error-message-align="right" :rules="[{ required: true, message: '请选择实习岗位' }]" />
      <van-popup  v-if="schoolCode != '10422'" v-model="showPicker5" round position="bottom">
        <van-picker show-toolbar :columns="gwList" @cancel="showPicker5 = false" @confirm="onConfirm5" />
      </van-popup>
      <van-field  v-if="schoolCode != '10422'"  disabled readonly v-model="form.bmks" name="部门/科室" label="部门/科室" input-align="right" />
      <van-field  v-if="schoolCode != '10422'"  disabled readonly v-model="form.qyls" name="企业老师" label="企业老师" input-align="right" error-message-align="right" />
      <van-field  v-if="schoolCode != '10422'"  disabled readonly v-model="form.qylsdh" label-width="10em" name="企业老师电话" label="企业老师电话" input-align="right" error-message-align="right" />
      <van-field  v-if="schoolCode != '10422'" disabled readonly name="岗位类别" v-model="pickerData2" input-align="right" label="岗位类别" />
      <van-field  v-if="schoolCode != '10422'" disabled readonly v-model="form.gwjs" rows="1" autosize label="岗位介绍" input-align="right" type="textarea" />
      <van-field  v-if="schoolCode != '10422'" disabled readonly v-model="form.gznr" rows="1" autosize label="工作内容" input-align="right" type="textarea" />

      <div class="bblock">实习信息</div>
      <van-field  required disabled readonly v-model="form.xnzdjsmc" label-width="10em" name="校内指导教师" label="校内指导教师" input-align="right" error-message-align="right" placeholder="请输入" :rules="[{ required: true, message: '请填写校内指导教师' }]" />
      <van-field  required disabled readonly name="calendar" :value="form.kssj" label="开始时间" input-align="right" is-link error-message-align="right" placeholder="请选择" :rules="[{ required: true, message: '请选择开始时间' }]" />
      <van-field  required disabled readonly name="结束时间" :value="form.jssj" label="结束时间" input-align="right" is-link error-message-align="right" placeholder="请选择" :rules="[{ required: true, message: '请选择结束时间' }]" />
      <van-field disabled readonly name="专业对口" label="专业对口" >
        <template #input>
          <van-radio-group icon="activeIcon" v-model="form.zydk" direction="horizontal" disabled>
            <van-radio name="1"
              >是
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>
            <van-radio name="0"
              >否
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="uploader" label="上传附件" :rules="[{ required: false, message: '请上传附件' }]">
        <template #input>
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
        </template>
      </van-field>
      <div class="button-box">
        <!-- <van-button round type="default" native-type="button" @click="saveInfo">暂存</van-button> -->
        <van-button round type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <reviewer-dialog :code="966" @change="reviewerChange" ref="dialog" @done="saveData()"></reviewer-dialog>
  </div>
</template>

<script>
import iApi from '@/utils/internship'
import { mapGetters } from 'vuex'
import ReviewerDialog from './components/reviewerDialog.vue'
import findPopup from "../internship/findPopup";
export default {
  components: {
    ReviewerDialog,
    findPopup
  },
  data() {
    return {
      schoolCode:'',
      isEdit: false,
      phone: /^1[3456789]\d{9}$/,
      activeIcon: require('../../../../../static/img/dxIcon.png'),
      inactiveIcon: require('../../../../../static/img/dxWxz.png'),
      form: {
        jdfzr: '',
        gznr: '',
        sxjssj: '',
        sxjdmc: '',
        sxjdid: '',
        xnzdjsid: '',
        sxgwid: '',
        gwmc: '',
        zydk: '',
        jddh: '',
        gwlb: '',
        sxjdlb: '',
        jddz: '',
        sxjhid: '',
        gwjs: '',
        qylsdh: '',
        qyls: '',
        ssqy: '',
        ssqymc: '',
        sxkssj: '',
        bmks: '',
        xnzdjsmc: '',
        userid: '',
        ysxjdid: '',
        ysxqyid: '',
        ysxgwid: '',
        tyshxydm: '',
        file: '',
        type: 'add',
        sxbgsqid: '', // 只有重新申请
      },
      fileList: [],
      preData: [{ title: '', list: [] }, { title: '', list: [] }, { title: '', list: [] }, { title: '', list: [] }, { title: '', list: [] }, { title: '', list: [] }, { title: '', list: [] }, { title: '', list: [] }],
      showPicker: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      pickerData: '',
      pickerData2: '',
      jdList: [],
      gwList: []
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
      timeRange: 'getTimeRange',
    }),
  },
  methods: {
    async getPreData() {
      const res = await iApi.getPreInfoList({
        sxjhid: this.sxjhid,
      })
      this.preData = res.data
      let pageData = {}
      if (this.isEdit) {
        pageData = await iApi.getReTyDetail({
          sxjhid: this.sxjhid,
        })
        this.form.type = 'edit'
        this.form.sxbgsqid = pageData.data.sxbgsqid
      } else {
        pageData = await iApi.getTyDetail({
          sxjhid: this.sxjhid,
        })
        this.form.type = 'add'
      }

      if (pageData.code == '1') {
        Object.keys(pageData.data).forEach(item => {
          this.form[item] = pageData.data[item]
        })
        this.form.ysxjdid = pageData.data.sxjdid
        this.form.ysxqyid = pageData.data.ssqy
        this.form.ysxgwid = pageData.data.sxgwid
        this.pickerData = pageData.data.sxjdlbmc
        this.pickerData2 = pageData.data.gwlbmc
      }
      const resSxjd = await iApi.getJdList({
        ssqy: this.form.ssqy
      })
      this.jdList = resSxjd.data
    },
    onConfirm(data) {
      this.form.sxjdlb = data.id
      this.pickerData = data.text
      this.showPicker = false
    },
    onConfirm2(data) {
      this.form.gwlb = data.id
      this.pickerData2 = data.text
      this.showPicker2 = false
    },
    /**
     * @description: 选择实习基地
     * @param {*} data
     * @return {*}
     */
    async onConfirm3(data) {
      this.form.sxjdmc = data.text
      this.form.sxjdid = data.id
      this.showPicker3 = false
       const res = await iApi.getGwListDetail({
        sxjdid: this.form.sxjdid
      })
      console.log(res)
      this.gwList = res.data.list
      this.form.jddh = res.data.jddh
      this.form.jddz = res.data.jddz
      this.form.jdfzr = res.data.jdfzr
      this.form.sxjdid = res.data.sxjdid
      this.form.sxjdlb = res.data.sxjdlb
      this.pickerData = res.data.sxjdlbmc
      this.form.sxjdmc = res.data.sxjdmc
      // 清空原岗位
      this.form.sxgwid = ''
      this.form.gwmc = ''
    },
    /**
     * @description: 选择所属单位
     * @param {*} data
     * @return {*}
     */
    async onConfirm4(data) {
      console.log(data)
      this.form.ssqy = data.id
      this.form.ssqymc = data.text
      this.showPicker4 = false
      const res = await iApi.getJdList({
        ssqy: this.form.ssqy
      })
      this.jdList = res.data
      // 清空基地和岗位
      this.form.sxjdmc = ''
      this.form.sxjdid = ''
      this.form.sxgwid = ''
      this.form.gwmc = ''
    },
    /**
     * @description: 选择实习岗位
     * @param {*} data
     * @return {*}
     */
    async onConfirm5(data) {
      console.log(data)
      this.form.sxgwid = data.id
      this.form.gwmc = data.text
      this.showPicker5 = false
      const res = await iApi.getGwDetail({
        sxgwid: this.form.sxgwid
      })
      Object.keys(res.data).forEach(item=>{
        this.form[item] = res.data[item]
      })
    },
    upload(e) {
      this.form.file = e.file
    },
    reviewerChange(e) {
      this.form.userid = e
    },
    onSubmit() {
      this.$refs.dialog.open()
    },
    async saveData() {
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postUniChangeData(this.form)
      if (res.code == 1) {
        if (!this.isEdit) {
          this.$toast.success('提交申请成功')
          setTimeout(() => {
            this.$router.replace({
              path: '/internship/applyStatus?config=6',
            })
          }, 800)
        } else {
          this.$toast.success('重新提交申请成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 800)
        }
      }
    },
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if (this.$route.query.isEdit) {
      this.isEdit = true
    }
    this.getPreData()
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}
.img-icon {
  height: 20px;
}
.bblock {
  height: 40px;
  background: #f2f2f4;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  margin-left: 15px;
  line-height: 50px;
}
.button-box {
  width: 100%;
  height: 70px;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.van-button {
  width: 345px;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/uniChange.vue